import { useMemo, useState } from 'react';
import PageContainer from 'src/pages/components/PageContainer';
import { createEezyguardClient } from 'src/apis/eezyguard';
import EezyGuardDashboard from 'src/pages/components/eezyguard/EezyGuardDashboard';
import { useEezyguardAdmin } from 'src/pages/components/eezyguard/common';

export default function EezyGuardAdminDashboard(): JSX.Element {
  const { isAdmin } = useEezyguardAdmin();
  const [error, setError] = useState('');
  const client = useMemo(() => createEezyguardClient('admin'), []);

  return (
    <PageContainer title="EezyLine" error={error} guard={() => isAdmin}>
      <EezyGuardDashboard client={client} onError={setError} />
    </PageContainer>
  );
}
